module.exports = __webpack_public_path__ + "static/media/alarm.b5dd1c3.wav";


//////////////////
// WEBPACK FOOTER
// ./static/audio/alarm.wav
// module id = +C7j
// module chunks = 24